// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import moment from 'moment'

export const exportValue = ({ columnKey, rowData }) => (
  rowData[columnKey]
    ? moment(rowData[columnKey]).format('YYYY/MM/DD HH:mm:ssa')
    : '-'
)

const FormatEpochToFullTimestamp = props => {
  const date = exportValue(props)
  return (
    <div title={date}>
      {date}
    </div>
  )
}

FormatEpochToFullTimestamp.propTypes = {
  columnKey: string.isRequired,
  rowData: object.isRequired,
}

export default FormatEpochToFullTimestamp
